<template lang='pug'>
  div.columns.is-vcentered.is-mobile
    div.column.has-text-centered
      CurrentTime
      h1 Digite sua senha numérica
      div.columns.container.is-centered.ma
        .field.column.is-one-third
          InputText(v-focus="", password=true, placeholder='Senha numérica', v-model="pwd", @keyup.enter="checkpwd",
            autocomplete="off", pattern="[0-9]*", required="true", type="tel" id="senhanumerica")
          Button3d(@click="checkpwd", color="primary", size="large", :block="true" id="confirmasenhanumerica") Confirmar

</template>

<script>
import { mapActions } from 'vuex'
import CurrentTime from '../../common/CurrentTime'

export default {
  mounted: function () {
    this.$nextTick(function () {
      this.$store.commit('password/resetState')
      this.$store.dispatch('password/startFirebaseMessaging')
    })
  },
  computed: {
    pwd: {
      get () {
        return this.$store.state.password.pwd
      },
      set (value) {
        this.$store.commit('password/pwd', value)
      }
    }
  },
  methods: {
    ...mapActions('password', ['checkpwd'])
  },
  components: {CurrentTime}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ma {
  margin: auto
}
input[type=tel] {
  -webkit-text-security: disc!important;
}
</style>
